import { Route } from '@angular/router';
import { AuthGuard } from '@nexchat/core/src/app/route-guards/redirect.guard';
import { USER_ROUTES } from '@nexchat/core/src/app/user/user.routes';
import { EnterpriseSignInComponent } from './pages/signin/signin.component';
import { EnterpriseSignUpComponent } from './pages/signup/signup.component';
import { EnterpriseNotFoundComponent } from './pages/not-found/not-found.component';
import { EnterpriseUserComponent } from './components/enterprise-user';

import { PROJECT_ROUTES } from '@nexchat/core/src/app/pages/project-list/projects.routes';

// Clone and extend core's USER_ROUTES to inject enterprise-specific routes
const enterpriseUserRoutes = JSON.parse(JSON.stringify(USER_ROUTES));

// Re-map the lazy-loaded components (since functions are lost in stringify, we reconstruct them)
enterpriseUserRoutes[0].loadComponent = () =>
  import('./components/enterprise-user').then((m) => m.EnterpriseUserComponent);

// Keep core's children, and append enterprise routes
enterpriseUserRoutes[0].children = [
  // Intercept the 'communication-templates' route and map it to our new dark-themed dashboard
  {
    path: 'communication-templates',
    loadComponent: () =>
      import('./components/communication-template/communication-template').then((m) => m.CommunicationTemplateComponent),
    title: 'Communication Templates'
  },
  {
    path: 'instance/include',
    loadComponent: () =>
      import('./components/enterprise-include-number/enterprise-include-number.component').then((m) => m.EnterpriseIncludeNumberComponent),
    title: 'Include Number'
  },
  ...USER_ROUTES[0].children,
  {
    path: 'workflow-settings',
    loadComponent: () =>
      import('./components/config-dashboard').then((m) => m.ConfigDashboardComponent),
    title: 'Workflow & Templates'
  },
  {
    path: 'enterprise-manager',
    loadComponent: () =>
      import('./components/enterprise-manager/enterprise-manager').then((m) => m.EnterpriseManagerComponent),
    title: 'Workspace Settings'
  },
  {
    path: 'projects/task-manage',
    loadComponent: () =>
      import('./components/task-manage/task-manage.component').then((m) => m.TaskManageComponent),
    title: 'Task Manage'
  },
  {
    path: 'projects/milestone/:id',
    loadComponent: () =>
      import('./components/enterprise-milestone-edit/enterprise-milestone-edit.component').then((m) => m.EnterpriseMilestoneEditComponent),
    title: 'Milestone'
  },
  {
    path: 'projects/milestone',
    loadComponent: () =>
      import('./components/enterprise-milestone-edit/enterprise-milestone-edit.component').then((m) => m.EnterpriseMilestoneEditComponent),
    title: 'Milestone'
  },
  {
    path: 'projects',
    children: PROJECT_ROUTES
  }
];

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/home/home.component').then((m) => m.EnterpriseHomeComponent),
  },
  {
    path: 'contact',
    loadComponent: () =>
      import('./pages/contact/contact.component').then((m) => m.ContactComponent),
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./pages/privacy-policy/privacy-policy.component').then((m) => m.EnterprisePrivacyPolicyComponent),
  },
  {
    path: 'refund-policy',
    loadComponent: () =>
      import('./pages/refund-policy/refund-policy.component').then((m) => m.EnterpriseRefundPolicyComponent),
  },
  {
    path: 'terms-of-service',
    loadComponent: () =>
      import('./pages/terms-of-service/terms-of-service.component').then((m) => m.EnterpriseTermsOfServiceComponent),
  },
  {
    path: 'faq',
    loadComponent: () =>
      import('./pages/faq/faq.component').then((m) => m.EnterpriseFaqComponent),
  },
  {
    path: 'signin',
    loadComponent: () =>
      import('./pages/signin/signin.component').then((m) => m.EnterpriseSignInComponent),
  },
  {
    path: 'signup',
    loadComponent: () =>
      import('./pages/signup/signup.component').then((m) => m.EnterpriseSignUpComponent),
  },
  {
    path: 'user',
    canActivate: [AuthGuard],
    children: enterpriseUserRoutes,
  },
  {
    path: 'admin',
    loadComponent: () =>
      import('./components/enterprise-user').then((m) => m.EnterpriseUserComponent),
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('@nexchat/core/src/app/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then((m) => m.EnterpriseNotFoundComponent),
  }
];
